import Validator from './Validator';

export default function validateBoostInvoiceAddress(form) {
  return Validator.create(form, {
    'invoiceAddress[street]': {
      validators: {
        notEmpty: {
          message: 'Straße ist ein Pflichtfeld',
        },
      },
    },
    'invoiceAddress[city]': {
      validators: {
        notEmpty: {
          message: 'Stadt ist ein Pflichtfeld',
        },
      },
    },
    'invoiceAddress[country]': {
      validators: {
        notEmpty: {
          message: 'Land ist ein Pflichtfeld',
        },
      },
    },
    'invoiceAddress[zipCode]': {
      validators: {
        notEmpty: {
          message: 'Postleitzahl ist ein Pflichtfeld',
        },
      },
    },
  });
}
